import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {
  DigitalCampaignConfigEasy,
  WrappedCampaignConfigEasy,
} from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-wrapped-campaign-easy',
    template: ''
})
export class WrappedCampaignEasyComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const inApp = this.isInApp(params);
      const productName = params['productName'];

      if (productName && productName === 'digital_enthusiast') {
        const config = { ...DigitalCampaignConfigEasy };
        if (inApp && config.redirectUri) {
          config.redirectUri = this.withInApp(config.redirectUri);
        }
        this.loginService.login(config);
      } else {
        const config = { ...WrappedCampaignConfigEasy };
        if (inApp && config.redirectUri) {
          config.redirectUri = this.withInApp(config.redirectUri);
        }
        this.loginService.login(config);
      }
    });
  }

  private isInApp(params: Params): boolean {
    if (params['inApp'] === true || params['inApp'] === 'true') {
      return true;
    }

    const currentUrl = new URL(window.location.href);
    if (currentUrl.searchParams.get('inApp') === 'true') {
      return true;
    }

    const hashQueryIndex = currentUrl.hash.indexOf('?');
    if (hashQueryIndex === -1) {
      return false;
    }

    return new URLSearchParams(currentUrl.hash.substring(hashQueryIndex)).get('inApp') === 'true';
  }

  private withInApp(redirectUri: string): string {
    if (redirectUri.includes('inApp=')) {
      return redirectUri;
    }

    const separator = redirectUri.includes('?') ? '&' : '?';
    return `${redirectUri}${separator}inApp=true`;
  }
}
